import {ApolloClient, InMemoryCache} from "@apollo/client";
import possibleTypes from "app/gql/possibleTypes";

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

export const apolloClient = new ApolloClient({
  uri: "/graphql",
  headers: {
    "x-csrf-token": csrfToken ?? ""
  },
  cache: new InMemoryCache({
    possibleTypes: possibleTypes.possibleTypes
  }),
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache"
    },
    mutate: {
      fetchPolicy: "no-cache"
    },
    watchQuery: {
      fetchPolicy: "no-cache"
    }
  }
});
